import { render, staticRenderFns } from "./CrmRejectionReasonPopupWrappable.vue?vue&type=template&id=4a92e116&scoped=true&lang=pug&"
import script from "./CrmRejectionReasonPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./CrmRejectionReasonPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./CrmRejectionReasonPopupWrappable.vue?vue&type=style&index=0&id=4a92e116&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a92e116",
  null
  
)

export default component.exports